<template>
<span data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      :id="dd_id ? dd_id : ''">
  <slot name="dd_cta"></slot>
  <div style="width: 100%; top: -20px!important;" class="dropdown mt-0">
    <div class="dropdown-menu dropdown-menu_navbar shadow animated--fade-in"
         :class="dd_position ? `dropdown-menu-${dd_position}` : 'dropdown-menu-right'"
         style="transform: translate3d(-140px, 0px, 0px)! important;"
         :aria-labelledby="dd_id ? dd_id : ''">
      <div v-for="(item, index) in dd_data" :key="`var_${index}`"
           @click.stop="clickOption(item)"
           style="z-index: 999!important;"
           class="d-flex border-bottom">
        <span class="cursor_pointer d-flex dropdown-item">
          <div class="">
            <i :class="item.icon" class="pr-2"></i> {{ item.name }}
          </div>
        </span>
      </div>
    </div>
  </div>
</span>
</template>

<script>
/***

 ## COMO USAR

 1) Declarar o componente <DropdownDefault /> no local onde deseja utilizá-lo, observando as "PROPS".

 2) Adicionar ao "mounted()" do componente o evento responsável por receber os dados do clique do DropDown.

    Exemplo:

    mounted() {
      // Recebe dados dos clique nos Dropdowns
      this.$root.$on('setClickOption', (payload) => {
        this.dropdownClickOption = payload;
      });
    },

 3) Criar propriedade no "data()" para receber os dados do evento.

    Exemplo ("dropdownClickOption"):

    data() {
      return {
        dropdownClickOption: null,
      }
    }

*/

export default {
  name: "DropdownDefault",
  mounted() {
    // Recebe dados dos clique nos Dropdowns
    // this.$root.$on('responseClick', (payload) => {
    //   this.show = payload;
    // });
  },
  data(){
    return {
      item_data: null,
      // show: null
    }
  },
  props: [
    'dd_id',
    'dd_position',
    'dd_data',
    'dd_click',
  ],
  methods: {
    clickOption(item){
      this.item_data = item
      this.$root.$emit('setClickOption', this.item_data);
      if(this.dd_click !== undefined) {
        this.dd_click();
      }
    },
  },
}
</script>

<style scoped>

</style>
